type Callback = () => void

let onUpdateAvailableCallback: Callback | null = null
let onChunkMissingCallback: Callback | null = null
let waitingWorker: ServiceWorker | null = null
let hasReloaded = false

export function onUpdateAvailable(cb: Callback) {
  onUpdateAvailableCallback = cb
}

export function onChunkMissing(cb: Callback) {
  onChunkMissingCallback = cb
}

export function applyUpdate() {
  if (waitingWorker) {
    waitingWorker.postMessage({ type: 'SKIP_WAITING' })
  }
}

export function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return
  }

  // Listen for controller change (new SW activated) → reload once
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hasReloaded) {
      hasReloaded = true
      window.location.reload()
    }
  })

  // Listen for messages from the SW
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'CHUNK_MISSING') {
      onChunkMissingCallback?.()
    }
  })

  navigator.serviceWorker.register('/sw.js').then((registration) => {
    // If there's already a waiting worker on load
    if (registration.waiting) {
      waitingWorker = registration.waiting
      onUpdateAvailableCallback?.()
      return
    }

    // Watch for new SW installing
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing
      if (!newWorker) return

      newWorker.addEventListener('statechange', () => {
        // New SW is installed and waiting
        if (
          newWorker.state === 'installed' &&
          navigator.serviceWorker.controller
        ) {
          waitingWorker = newWorker
          onUpdateAvailableCallback?.()
        }
      })
    })
  })
}
